export const ACTIVITY_TYPE_OPTIONS = [
  { key: "call", label: "Call" },
  { key: "email", label: "Email" },
  { key: "meeting", label: "Meeting" },
  { key: "task", label: "Task" },
];
